export default "__VITE_ASSET__3F3PTL27__";